:host {
  display: inline;
}

.spw-card-subtag-item {
  color: var(--spw-ds-primary);
  font-size: 15px;
  font-weight: 700;
  &--has-link {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
